var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.583 3.763 6.86 5.209a.59.59 0 1 0 .76.905l2.982-2.504a.588.588 0 0 0 .165-.223.59.59 0 0 0-.134-.744L7.648.138a.59.59 0 0 0-.759.905l1.835 1.538H3.392a.59.59 0 0 0-.173.027A3.149 3.149 0 1 0 4.38 8.684l-.27-1.172a1.968 1.968 0 1 1-.862-3.724l-.006-.025h5.34z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.cc9abb1ba86343c02c5de838a7c52ff4.svg";
export { ForwardRef as ReactComponent };